import { angularInjectorProvider } from 'Injector';
import { type FrontRoyalRootScope } from './FrontRoyal.types';

export function useRootScope() {
    return angularInjectorProvider.get<FrontRoyalRootScope>('$rootScope');
}
